import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '✈️',
    title: 'pages.onboarding.whyQuestion.answer1',
  },
  {
    emoji: '💼',
    title: 'pages.onboarding.whyQuestion.answer2',
  },
  {
    emoji: '🏠',
    title: 'pages.onboarding.whyQuestion.answer3',
  },
  {
    emoji: '📚',
    title: 'pages.onboarding.whyQuestion.answer4',
  },
  {
    emoji: '🎭',
    title: 'pages.onboarding.whyQuestion.answer5',
  },
  {
    emoji: '🤔',
    title: 'pages.onboarding.whyQuestion.answer6',
  },
]

export default function WhyQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.whyQuestion.title"
    />
  )
}
